export const twentyFourHrFormat = (localTime, useAmPm = false) => {
  if (!localTime) return null;

  const date = new Date(localTime);
  const isMidnight = date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0;


  if (isMidnight) {
    return date.toLocaleDateString('en-GB', { 
      day: '2-digit', 
      month: 'short', 
      year: '2-digit' 
    }).replace(/ /g, '/');
  }

  const dateStr = date.toLocaleDateString('en-GB', { 
    day: '2-digit', 
    month: 'short', 
    year: '2-digit' 
  }).replace(/ /g, '/');

  const timeStr = useAmPm 
    ? date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })
    : date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });

  return `${dateStr} ${timeStr}`;
};

export const parseAndConvertToLocal = (reportedDate) => {
  try {
    if (!reportedDate) return null;
    
    // If the date string doesn't have timezone info, treat it as UTC
    let dateString = reportedDate;
    if (!dateString.includes('T') && !dateString.includes('Z') && !dateString.includes('+')) {
      // Add 'Z' to indicate UTC if it's in format "YYYY-MM-DD HH:mm:ss"
      dateString = dateString.replace(' ', 'T') + 'Z';
    }
    
    const dateTime = new Date(dateString);
    if (isNaN(dateTime.getTime())) return null;
    
    return dateTime;
  } catch (e) {
    return null;
  }
};

export const formatDateString = (dateString) => {
  if (!dateString) return null;
  
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return null;
    
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  } catch (e) {
    return null;
  }
};

export const convertMinutesToHoursAndMinutesShort = (totalMinutesString) => {
  if (!totalMinutesString || 
      totalMinutesString === '' || 
      totalMinutesString === 'null' || 
      totalMinutesString === 'N/A') {
    return '0m';
  }

  const totalMinutes = parseInt(totalMinutesString);

  if (isNaN(totalMinutes) || totalMinutes <= 0) {
    return '0m';
  }

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours === 0) {
    return `${minutes}m`;
  } else if (minutes === 0) {
    return `${hours}h`;
  } else {
    return `${hours}h ${minutes}m`;
  }
};